import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=e6ce5450&"
import script from "./ProductCategoryList.ts?vue&type=script&lang=js&"
export * from "./ProductCategoryList.ts?vue&type=script&lang=js&"
import style0 from "./ProductCategoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports